import type { JSX } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import InfoTooltip from "app/pages/sales-intelligence/pages/company-analysis/components/shared/InfoTooltip/InfoTooltip";

type SectionTitleProps = {
    text: string;
    tooltipContent: JSX.Element;
};

const SectionTitle = (props: SectionTitleProps) => {
    const { text, tooltipContent } = props;

    return (
        <Flex
            alignItems="center"
            gap="10px"
            padding="20px 24px 18px"
            borderBottom={`1px solid ${colorsPalettes.carbon["100"]}`}
        >
            <Text
                data-automation="page-title"
                fontVariant="h5"
                color={colorsPalettes.carbon["500"]}
            >
                {text}
            </Text>
            <InfoTooltip content={tooltipContent} />
        </Flex>
    );
};

export default SectionTitle;
